import { Button, InputAdornment, TextField } from "@mui/material";
import React, { Fragment, useState } from "react";
import { login, loginVrify } from "../actions/security";

import { Col } from "react-bootstrap";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import LanguageHolder from "../components/Admin/Reusable/LanguageHolder";
import VerificationCodeInput from "../components/Admin/Reusable/VerificationCodeInput";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    email: "",
    password: "",
    code: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isCodeVerification, setIsCodeVerification] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChangeHandler = (event) => {
    changeState(event.target.name, event.target.value);
  };

  const changeState = (propName, value) => {
    setState((prevState) => ({ ...prevState, [propName]: value }));
  };

  const handleLogin = (event) => {
    event.preventDefault();
    if (isCodeVerification) {
      const item = {
        code: state.code,
      };
      if (state.code) {
        // Ovde ide poziv API-ja za validaciju koda
        dispatch(loginVrify(item, navigate));
      } else {
        toast.error("Morate uneti 6 cifara", { theme: "colored" });
      }
    } else {
      dispatch(login(state))
        .then(() => {
          setIsCodeVerification(true);
        })
        .catch((error) => {
          setIsCodeVerification(false);
          console.error("Greška prilikom logovanja:", error);
        });
    }
  };

  const onChangeHandlerOtp = (value) => {
    // Ažuriramo stanje u roditeljskoj komponenti
    setState((prevState) => ({ ...prevState, code: value }));
  };

  return (
    <Fragment>
      <div className="language-section-login">
        <LanguageHolder />
      </div>
      <div className="auth-container-main">
        <div className="auth-container-content">
          <div className="auth-container-image d-flex align-items-center justify-content-center">
            <img
              src="/images/login-banner-2.jpg"
              alt="logo"
              className="img-fluid"
            />
          </div>
          <div className="auth-container-form d-flex align-items-center justify-content-evenly flex-column">
            <div className="auth-content-form">
              <div className="auth-content-form-logo ">
                <img
                  src="/images/login-logo3.png"
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="auth-content-form-title ">
                <h1>{t("login.title")}</h1>
                <h3>{t("login.subtitle")}</h3>
              </div>
              <form onSubmit={handleLogin} className="">
                <div className="auth-content-form-inputs">
                  {isCodeVerification ? (
                    <Col lg={12} className="mb-3">
                      <h6 className="mb-3">
                        Proverite svoj inbox i unesite 6-cifreni verifikacioni
                        kod (OTP) koji smo poslali na Vašu e-mail adresu{" "}
                        <b>{state.email}</b> za završetak prijave.
                      </h6>
                      <VerificationCodeInput onChange={onChangeHandlerOtp} />
                    </Col>
                  ) : (
                    <Fragment>
                      <div className="mb-3">
                        <TextField
                          label={t("login.email")}
                          name="email"
                          value={state.email}
                          onChange={(e) => onChangeHandler(e)}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailOutlinedIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                      <div className="position-relative auth-pass-inputgroup">
                        <TextField
                          label={t("login.password")}
                          name="password"
                          value={state.password}
                          onChange={(e) => onChangeHandler(e)}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <HttpsOutlinedIcon />
                              </InputAdornment>
                            ),
                          }}
                          type={showPassword ? "text" : "password"}
                          className="mb-4"
                        />
                        {showPassword ? (
                          <VisibilityOffIcon
                            className="icon-show-hide-password-input"
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        ) : (
                          <VisibilityIcon
                            className="icon-show-hide-password-input"
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        )}
                        <button
                          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                          type="button"
                          id="password-addon"
                          fdprocessedid="zb3phh"
                        >
                          <i className="ri-eye-fill align-middle"></i>
                        </button>
                      </div>
                    </Fragment>
                  )}
                </div>

                <div className="auth-content-form-forgot text-end">
                  {/* <h5>{t("login.forgot-password")}?</h5> */}
                </div>
                <div className="auth-content-form-button">
                  <div className="mt-4">
                    <Button
                      size="large"
                      type="submit"
                      variant="contained"
                      className="text-center w-100"
                    >
                      {t("login.button")}
                    </Button>

                    {isCodeVerification && (
                      <Button
                        size="large"
                        variant="contained"
                        className="text-center w-100 mt-3 return-login-button"
                        onClick={() => setIsCodeVerification(false)}
                      >
                        Vrati se nazad na prijavu
                      </Button>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="auth-content-form-footer text-center">
              <p className="mb-0">
                {t("login.admin-portal")} | {t("login.powerd-by")} AMAI
              </p>
              <p>©2025 LG</p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
